// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3pcKL","messages":"Chat_messages__1dvxg","dateDivider":"Chat_dateDivider__1u5tc"};